import { isEqual } from 'lodash';
import React, { useEffect } from 'react';
import { PiTrashDuotone } from 'react-icons/pi';
import { Button, Input } from 'rizzui';
import CustomSelect from '../../../components/forms/CustomSelect';
import DateField from '../../../components/forms/DateField';
import { usePrivilege } from '../../../components/priviledge/PriviledgeProvider';
import useRoles from '../../../hooks/api-calls/useRoles';
import { FilterOptions } from '../../../hooks/useFilters';
import { RootState } from '../../../redux/store';
import { useSelector } from 'react-redux';
import useCompanies from '../../../hooks/api-calls/useCompanies';

interface UsersFiltersProps {
    updateFilters: (filters: any) => void
    resetFilters: (limit: any) => void
    filters: FilterOptions
}

const UsersFilters: React.FC<UsersFiltersProps> = ({ filters, updateFilters, resetFilters }) => {

    // HOOKS

    const { userCan } = usePrivilege();
    const { getRolesList, updateRolesHookFilters } = useRoles();
    const { getCompaniesList } = useCompanies();
    const { user } = useSelector((state: RootState) => state.auth);
    const companyId = user?.companyId;

    // USE EFFECTS

    useEffect(() => {
        if(!companyId) return;
        updateFilters({ company: companyId });
        updateRolesHookFilters({
        filter_filters: {
            companyId: companyId,
            },
        });
    }, [companyId]);

    // RENDER

    return (
        <>
           <Input
                id="name"
                label="Nombre"
                placeholder="Buscar por nombre"
                value={filters.filter_filters?.name ?? ''}
                onChange={(e: any) => updateFilters({ name: e.target.value })}
            />

            <Input
                id="email"
                label="Correo electrónico"
                placeholder="Buscar por correo electrónico"
                value={filters.filter_filters?.email ?? ''}
                onChange={(e: any) => updateFilters({ email: e.target.value })}
            />

            <CustomSelect
                isSearchable
                id={'active'}
                label="Estado"
                options={[
                    { label: 'Todos', value: 'null' },
                    { label: 'Activos', value: true },
                    { label: 'Desactivados', value: false }
                ]}
                onChange={(e: any) => {
                    if (e.value === 'null') {
                        updateFilters({ active: null });
                        return;
                    }
                    updateFilters({ active: e.value });
                }}
                value={filters.filter_filters?.active !== null
                    ? { label: filters.filter_filters?.active ? 'Activo' : 'Desactivado', value: filters.filter_filters?.active }
                    : { label: 'Todos', value: 'null' }}
            />

            {userCan('list', 'companies') ? (
                <CustomSelect
                    isSearchable
                    id={'company'}
                    label="Compañia"
                    options={getCompaniesList()}
                    onChange={(e: any) => { 
                        updateFilters({ company: e.value})
                    }}
                    value={
                        filters.filter_filters?.company
                            ? getCompaniesList().filter((company: any) => filters.filter_filters?.company.includes(company.value))
                            : null
                           
                    }
                    display={userCan('list', 'companies')}
                />
            ) : null}

            <CustomSelect
                isSearchable
                isMulti
                id={'roleId'}
                label="Rol"
                options={getRolesList()}
                onChange={(e: any) => { updateFilters({ roles: e.map((rol: any) => rol.value) }) }}
                value={
                    filters.filter_filters?.roles
                        ? getRolesList().filter((rol: any) => filters.filter_filters?.roles.includes(rol.value))
                        : []
                }
                display={userCan('list', 'roles')}
            />

            <DateField
                isClearable
                className="w-full"
                label="Fecha de última conexión"
                placeholderText="Selecciona las fechas"
                startDate={filters.filter_filters?.between_dates?.startDate ? new Date(filters.filter_filters.between_dates.startDate) : null}
                endDate={filters.filter_filters?.between_dates?.endDate ? new Date(filters.filter_filters.between_dates.endDate) : null}
                onChange={(date: any) => {
                    const filters_between_dates = filters.filter_filters?.between_dates;
                    const between_dates = date ? { startDate: date[0], endDate: date[1] } : null;

                    if (between_dates && !isEqual(filters_between_dates, between_dates)) {
                        updateFilters({ between_dates: { startDate: date[0], endDate: date[1] } });
                    } else if (!between_dates && filters_between_dates) {
                        updateFilters({ between_dates: null });
                    }
                }}
            />

            <Button
                size="sm"
                onClick={() => {
                    resetFilters(50);
                }}
                variant="flat"
                className="h-9 bg-gray-200/70"
            >
                <PiTrashDuotone className="me-1.5 h-[17px] w-[17px]" /> Limpiar
            </Button>
        </>
    );
};

export default UsersFilters;